/*global System, $, Promise, _, THREE, virtualDom, Redux, Rx, TweenMax, Stats, console */

import {store, store$} from "./_config-store";
import {setupInteriorBuilder} from "./_interior-builder";
import {setupExteriorBuilder} from "./_exterior-builder";
import {delegate, convertName, getFile, getFabs, getVNodeFromHMTL, getHashParameter, updateHashParameters} from "./_utilities";

const h = virtualDom.h;

let headerVTreePrimary, headerVNodePrimary,
	headerVTreeSecondary, headerVNodeSecondary,
	selectorVTree, selectorVNode,
	infoVTree, infoVNode,
	fabOverlayVTree, fabOverlayVNode,
	viewerVTree, viewerVNode,
	$viewerContainer, $headerContainerPrimary, $headerContainerSecondary,
	$selectorContainer, $infoContainer, $fabOverlayContainer,
	interiorBuilder, exteriorBuilder,
	resizeSubscription,
	md = new MobileDetect(window.navigator.userAgent),
	mobile = md.mobile(),
	webgl = checkWebglSupport();

function checkWebglSupport() {
	if (!window.WebGLRenderingContext)return false;
	try {
		var _canvas = document.createElement('canvas');
		var _gl = _canvas.getContext('webgl') || _canvas.getContext('experimental-webgl');
		_gl.clearStencil(0);
		var errors = _gl.getError();
		return errors == 0;
	} catch (e) {
		return false;
	}
}

function getOptionsMatrix() {
	// get options matrix and update store
	let p = new Promise(function (resolve, reject) {
		$.ajax({
			url: "https://freightlinertrucks.azurewebsites.net/umbraco/Api/ConfiguratorMapping",
		}).done(function (response) {
			let //data = response,
				data = JSON.parse(response.json),
				optionsMatrix = _.mapValues(_.groupBy(data, "Mode"), function (mode) {
					return _.mapValues(_.groupBy(mode, "Component"), function (component) {
						return _.mapValues(_.groupBy(component, "Category"), function (option) {
							return option;
						});
					});
				});
			resolve(optionsMatrix);
		}).fail(function (e) {
			reject("failed to get options matrix", e);
		});
	});
	return p;
}
function getAdsFabs() {
	// get ADS Fabs and update store
	let hdnRoot = document.getElementById('root');
	let root = (hdnRoot) ? hdnRoot.value : 'https://freightlinertrucks.azurewebsites.net';	
	let p = new Promise(function (resolve, reject) {
		$.ajax({
			// url: "https://adsws.dtnaapps.com/SalesToolWebService.asmx/AssetManifest?app=ftl&version=qa",
			url: "/umbraco/surface/configurator/Fab",
			dataType: 'json'
		}).done(function (data) {			
			let fabs = JSON.parse(data.json);
			resolve(fabs);
		}).fail(function (e) {
			reject("failed to get ads fabs", e);
		});
	});
	return p;
}

function generateBuilderOptionGroups(state, options, buildSettings, categoryRules) {
	return _.chain(options).map((component, componentKey) => {
		let currentOption = "",
			optionGroup;
		if (componentKey === "Cab") {
			return false;
		}
		if (_.includes(categoryRules, componentKey)) {
			optionGroup = [h("div.btn-group.btn-num-" + options.length, {
				attributes: {
					"data-toggle": "buttons"
				}
			}, _.chain(component).map((category, categoryKey) => {
				let attributes = {
						"type": "radio",
						"name": componentKey,
						"autocomplete": "off",
						"data-name": categoryKey,
						// "data-incompatibilities": option.Incompatibilities,
						"data-key": categoryKey,
						"data-category": categoryKey,
						"data-component": componentKey
					},
					activeBtn = categoryKey === buildSettings[componentKey],
					disabledBtn = false;
				// disabledBtn = _.some(_.map(option.Incompatibilities.split(";"), function (inc) {
				// 	return _.includes(buildSettings, inc);
				// }), Boolean);
				if (_.some(category, (option) => {
						return _.some(option, prop => {
							return prop === "X" || prop === "*";
						});
					})) {
					return h("label.btn" +
						(activeBtn && !disabledBtn ? ".active" : "") +
						(disabledBtn ? ".disabled" : "") +
						(componentKey === "Seat Upholstery" ? ".btn-seat.btn-" + categoryKey : "") +
						(componentKey === "Color" ? ".btn-color.btn-" + categoryKey : ""), [
						h("input.build-option", {
							attributes: attributes
						}),
						categoryKey
					]);
				} else {
					return false;
				}
			}).compact().value())];
		} else {
			optionGroup = _.chain(component).map(category => {
				let options = _.chain(category).map(option => {
					let attributes = {
							"type": "radio",
							"name": option.Component,
							"autocomplete": "off",
							"data-name": option.Option,
							"data-incompatibilities": option.Incompatibilities,
							"data-key": option.Key,
							"data-category": option.Category,
							"data-component": option.Component
						},
						activeBtn = option.Key === buildSettings[option.Component],
						disabledBtn = _.some(_.map(option.Incompatibilities.split(";"), function (inc) {
							return _.includes(buildSettings, inc);
						}), Boolean);
					//console.log(option, option.Incompatibilities, buildSettings, disabledBtn);
					if (activeBtn && !disabledBtn) {
						attributes.checked = "checked";
						currentOption = option.Option;
					}
					if (disabledBtn) {
						attributes.disabled = "disabled";
					}
					if (option[state.truckModel + " " + state.truckCab] !== "") {
						return h("label.btn" +
							(activeBtn && !disabledBtn ? ".active" : "") +
							(disabledBtn ? ".disabled" : "") +
							(componentKey === "Seat Upholstery" ? ".btn-seat.btn-" + option.Key : "") +
							(componentKey === "Color" ? ".btn-color.btn-" + option.Key : ""), [
							h("input.build-option", {
								attributes: attributes
							}),
							(option.Option === "Not Equipped" ? "None" : option.Option)
						]);
					}
					return false;
				}).compact().value();
				if (options.length > 0) {
					return h("div.btn-group.btn-num-" + options.length, {
						attributes: {
							"data-toggle": "buttons"
						}
					}, options);
				}
				return false;
			}).compact().value();
		}
		if (optionGroup.length > 0) {
			return h("div.option-group", [
				h("h2.category-header.icon-info", [
					componentKey,
					(componentKey === "Color" ||
					componentKey === "Seat Upholstery") ?
						h("span.current", ": " + currentOption) : "",
				]),
				h("div.category-info", [
					h("p", "some stuff about the category...")
				]),
				optionGroup
			]);
		}
		return false;
	}).compact().value();
}

function generateBuilderVDom(state, options, buildSettings, categoryRules) {
	if (state.truckCab === "" || state.nav === "explore") {
		return h("div");
	}
	if (_.isArray(options)) {
		return h("div.vdom." + state.nav, [
			h("p", [
				h("strong", "NOTE: "),
				"The following do not change the look of the truck.",
				h("br"),
				"For full details and configurations, please contact your dealer."
			]),
			_.map(options, option => {
				return h("div", [
					h("h3", option[1]),
					generateBuilderOptionGroups(state, option[0], buildSettings, categoryRules)
				]);
			})
		]);
	} else {
		return h("div.vdom." + state.nav, generateBuilderOptionGroups(state, options, buildSettings, categoryRules));
	}
}

function generateBuilderUI(state) {
	let options,
		buildSettings,
		categoryRules = false;
	switch (state.viewOption) {
		case "Exterior":
			buildSettings = state.exteriorBuildSettings;
			options = state.optionsMatrix.Exterior;
			break;
		case "Interior":
			buildSettings = state.interiorBuildSettings;
			options = state.optionsMatrix.Interior;
			break;
		case "Powertrain/Chassis":
			buildSettings = state.powertrainBuildSettings;
			options = _.pick(state.optionsMatrix.Components, state.powertrainOptions);
			categoryRules = state.powertrainCategoryRules;
			break;
		case "Safety/Connectivity":
			buildSettings = state.safetyBuildSettings;
			options = [
				[
					_.pick(state.optionsMatrix.Components, state.safetyOptions),
					"Safety"
				],
				[
					_.pick(state.optionsMatrix.Components, state.connectivityOptions),
					"Connectivity"
				]
			];
			break;
	}
	return generateBuilderVDom(state, options, buildSettings, categoryRules);
}

function getOptionNames(settings, modeObj, categoryKey, optionKey) {
	return _.chain(settings).mapValues((value, key) => {
		let option = _.find(_.deepPluck(modeObj, key + ".*"), {"Key": value}),
			name = option && option.Option;
		return name;
	}).pickBy(o => {
		return o;
	}).value();
}
function getTruckDetails(state) {
	let truckDetails = {};
	truckDetails.exterior = getOptionNames(state.exteriorBuildSettings,
		state.optionsMatrix["Exterior"]);
	truckDetails.interior = getOptionNames(state.interiorBuildSettings,
		state.optionsMatrix["Interior"]);
	truckDetails.powertrain = getOptionNames(state.powertrainBuildSettings,
		state.optionsMatrix["Components"]);
	truckDetails.safety = getOptionNames(state.safetyBuildSettings,
		state.optionsMatrix["Components"]);
	truckDetails.connectivity = getOptionNames(state.connectivityBuildSettings,
		state.optionsMatrix["Components"]);
	console.log("truckDetails", truckDetails);
	return truckDetails;
}

function launchConfigurator() {
	$("body").addClass("configurator-mini-open");
	$("#configurator-mini").addClass("open");
	loadData();
}

function addHandlers() {

	$("comp-truck-hero .configure, .page-nav-holder .configure, [build] .configure")
		.on("click", launchConfigurator);

	const configuratorEl = document.getElementById("configurator-mini");
	// get clicks on the interior build options and update the button and the viewer
	const buildChanges$ = delegate(configuratorEl, ".build-option", "change");
	buildChanges$.subscribe(e => {
		let $target = $(e.delegate),
			buildSetting = {},
			state = store.getState();
		buildSetting[$target.attr("data-component")] = $target.attr("data-key");
		if (state.viewOption === "Powertrain/Chassis") {
			store.dispatch({
				type: 'POWERTRAIN_BUILD_CHANGE',
				buildSetting
			});
		} else if (state.viewOption === "Safety/Connectivity") {
			store.dispatch({
				type: 'SAFETY_BUILD_CHANGE',
				buildSetting
			});
		} else if (state.view === "interior") {
			store.dispatch({
				type: 'INTERIOR_BUILD_CHANGE',
				buildSetting
			});
		} else if (state.view === "exterior") {
			store.dispatch({
				type: 'EXTERIOR_BUILD_CHANGE',
				buildSetting
			});
		}
	});

	// change main nav {explore, build}
	const mainNav$ = delegate(configuratorEl, ".main-nav", "click");
	mainNav$.subscribe(e => {
		e.event.preventDefault();
		let $target = $(e.delegate);
		store.dispatch({
			type: 'MAIN_NAV_CHANGE',
			data: $target.attr("data-main-nav")
		});
	});

	// change view {exterior, interior}
	const viewerChange$ = delegate(configuratorEl, ".view-nav", "change");
	viewerChange$.subscribe(e => {
		let $target = $(e.delegate),
			view = $target.attr("data-view");

		updateHashParameters({view});
		store.dispatch({
			type: 'VIEW_CHANGE',
			data: view
		});
	});

	// change pillar
	const pillarChange$ = delegate(configuratorEl, ".pillar-nav", "click");
	pillarChange$.subscribe(e => {
		e.event.preventDefault();
		let $target = $(e.delegate),
			pillar = $target.attr("data-pillar");
		if ($target.hasClass("disabled")) {
			return;
		}
		updateHashParameters({
			pillar: pillar.replace(" ", "_")
		});
		store.dispatch({
			type: 'PILLAR_CHANGE',
			data: $target.attr("data-pillar")
		});
		$("html, body, #configurator-mini").animate({
			scrollTop: 0
		});
	});

	// rotate to show hotspots
	const showHotspots$ = delegate(configuratorEl, ".view-hotspots", "click, touchstart");
	showHotspots$.subscribe(() => {
		store.dispatch({
			type: 'PILLAR_CHANGE',
			data: store.getState().pillar
		});
	});

	// change view option
	const viewOption$ = delegate(configuratorEl, ".view-option-nav", "click");
	viewOption$.subscribe(e => {
		e.event.preventDefault();
		let $target = $(e.delegate),
			viewOption = $target.attr("data-view-option");
		if ($target.hasClass("disabled")) {
			return;
		}

		store.dispatch({
			type: 'VIEW_OPTION_CHANGE',
			data: viewOption
		});

	});

	// open hotspot info overlay
	const hotspotSelect$ = delegate(configuratorEl, ".hotspot-label", "click, touchstart");
	hotspotSelect$.subscribe(e => {
		var data = JSON.parse($(e.delegate).attr("data-fab"));
		console.log(data);
		store.dispatch({
			type: 'ACTIVE_FAB_CHANGE',
			data: data
		});
	});

	// close hotspot info overlay
	const hotspotOverlayClose$ = delegate(configuratorEl, "#hotspot-overlay .close", "click");
	hotspotOverlayClose$.subscribe(() => {
		store.dispatch({
			type: 'ACTIVE_FAB_CLEAR',
			data: ""
		});
	});

	// choose cab type and cab
	const chooseCabType$ = delegate(configuratorEl, "#configurator-selector .cab", "click");
	const chooseCabOption$ = delegate(configuratorEl, "#drawer .cab-option", "click");
	Rx.Observable.merge(chooseCabType$, chooseCabOption$).subscribe(e => {
		let $target = $(e.delegate);
		e.event.preventDefault();
		console.log($target.attr("class"))
		if ($target.hasClass("cab-option")) {
			toggleDrawer();
		}

		updateHashParameters({
			truck: convertName(store.getState().truckModel + "-" + $target.attr("data-truck-cab"))
		});

		store.dispatch({
			type: 'CAB_CHANGE',
			data: {
				cabType: $target.attr("data-cab-type"),
				truckCab: $target.attr("data-truck-cab")
			}
		});
	});

	const backToCabSelection$ = delegate(configuratorEl,
		"#configurator-header-primary .btn-back, #configurator-header-secondary .btn-back",
		"click");
	backToCabSelection$.subscribe(e => {
		let $target = $(e.delegate);
		updateHashParameters();
		store.dispatch({
			type: 'CAB_RESET',
			data: ""
		});

	});
	// slide hotspot slider
	const slideHotspotSlider$ = delegate(configuratorEl, ".hotspot-slide .btn", "click");
	slideHotspotSlider$.filter(e => {
		return !$(e.delegate).hasClass("btn-jwlauncher");
	}).subscribe(e => {
		let $target = $(e.delegate),
			$slide = $target.parent(),
			$newSlide;
		if ($target.hasClass("prev")) {
			$slide.removeClass("active").addClass("next");
			$newSlide = $slide.prev();
			$newSlide.addClass("prev");
			$newSlide.removeClass("prev").addClass("active");
		} else {
			$slide.removeClass("active").addClass("prev");
			$newSlide = $slide.next();
			$newSlide.addClass("next");
			$newSlide.removeClass("next").addClass("active");
		}
		console.log($slide, $newSlide);
		store.dispatch({
			type: 'ACTIVE_FAB_CHANGE',
			data: JSON.parse($newSlide.attr("data-fab"))
		});
	});

	const categoryInfo$ = delegate(configuratorEl, ".category-header", "click");
	categoryInfo$.subscribe(e => {
		let $header = $(e.delegate),
			$info = $header.next(".category-info");
		if ($info.hasClass("open")) {
			$info.stop().slideUp().removeClass("open");
		} else {
			$info.stop().slideDown().addClass("open");
		}
	});

	const sendToDealerBtn$ = delegate(configuratorEl, "#btn-send-to-dealer", "click");
	sendToDealerBtn$.subscribe(e => {
		// add the truck details to the details area of the send to dealer form
		let state = store.getState(),
			$detailWrap = $("#send-to-dealer .detail-wrap"),
			truckDetails = getTruckDetails(state),
			details = _.chain(truckDetails).map((settings, skey) => {
				return '<div class="detail-category"><h3>' + _.capitalize(skey) + '</h3><ul>' +
					_.chain(settings).map((setting, key) => {
						return '<li><strong>' + key + ':</strong> ' + setting + '</li>';
					}).value().join("") +
					'</ul></div>';
			}).value().join("");
		console.log("details", details);
		$detailWrap.html(details);

		store.dispatch({
			type: "VIEW_CHANGE",
			data: "exterior"
		});

		$("#send-to-dealer").addClass("active");
		// move the exterior viewer to the dealer form
		$("#configurator-viewers").appendTo("#send-to-dealer #truck");
		exteriorBuilder.resize(store.getState());
	});

	const closeSendToDealerBtn$ = delegate(configuratorEl, "#send-to-dealer .btn-back", "click");
	closeSendToDealerBtn$.subscribe(e => {
		$("#send-to-dealer").removeClass("active");
		// move the exterior viewer back to configurator location
		$("#configurator-viewers").insertAfter("#configurator-selector");
		exteriorBuilder.resize(store.getState());
	});

	const submitToDealer$ = Rx.Observable.fromEvent($("#send-to-dealer-form"), "submit");
	submitToDealer$.subscribe(e => {
		console.log("form", e);
		let $form = $(e.target),
			$errorFields = $form.find(".validate").not(".valid"),
			state = store.getState(),
			truckDetails = getTruckDetails(state);
		$form.find(".validate").removeClass("error");
		if ($errorFields.length > 0) {
			e.preventDefault();
			$errorFields.addClass("error");
			console.log(truckDetails);
		} else {
			// add the data to the form
			$form.find(".truck-details").val(JSON.stringify(truckDetails));
		}
	});

	const drawerHandle$ = delegate(configuratorEl, "#handle", "click");
	drawerHandle$.subscribe(e => {
		let $drawer = $("#drawer");
		e.event.preventDefault();
		toggleDrawer();
	});

	const mainClose$ = delegate(configuratorEl, "#configurator-header-primary .close", "click");
	mainClose$.subscribe(e => {
		$("body").removeClass("configurator-open");
		$(configuratorEl).removeClass("open");
		resizeSubscription.unsubscribe();
		store.dispatch({
			type: "CAB_RESET",
			data: ""
		});
	});


}

function toggleDrawer() {
	let $drawer = $("#drawer");
	console.log("drawer", $drawer.hasClass("open"))
	if ($drawer.hasClass("open")) {
		$drawer.removeClass("open");
		$drawer.find(".cab-options").slideUp();
		$("html, body").animate({
			scrollTop: 0
		});
	} else {
		$drawer.addClass("open");
		$drawer.find(".cab-options").slideDown();
		$("html, body").animate({
			scrollTop: $drawer.find("#handle").offset().top
		});
	}
}

function htmlDecode(input) {
	if (input[0] === "&") {
		let e = document.createElement('div');
		e.innerHTML = input;
		return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
	} else {
		return input;
	}
}


function generateExplorerOverlay(state) {
	if (!state.dataReady || state.truckCab === "") {
		return h("div.vdom.explore");
	}
	let hotspots = getFabs(state, (!webgl || state.view === "interior")),
		activeFab = state.activeFab || (!webgl && state.view === "interior" ? hotspots[0] : state.activeFab);
	return h("div.vdom.explore" + (activeFab ? ".active" : ""),
		h("div.fab-wrap", [
			(webgl ? h("div.close") : ""),
			h("div.hotspot-content" + (activeFab && activeFab.file === "blank.png" ? ".disabled" : ""), activeFab ? [
				h("div.img", {
					attributes: {
						style: 'background: url("//freightlineradsaem.azureedge.net/' + activeFab.file + '") center center no-repeat; ' +
						'background-size: contain;'
					}
				})
			] : ""),
			h("div.hotspot-slider",
				_.map(hotspots, (hotspot, i) => {
					let attributes = {
							"data-fab": JSON.stringify(hotspot)
						},
						windowHeight = window.innerHeight ? window.innerHeight : $(window).height(),
						sliderHeight = (activeFab.file === "blank.png" ? windowHeight :
							(windowHeight - ($(window).width() * 0.75)));
					if (mobile) {
						attributes.style = "height: " +
							sliderHeight + "px";
					}
					return h("div.hotspot-slide" +
						(i === activeFab.index - 1 ? ".prev" : "") +
						(i === activeFab.index ? ".active" : "") +
						(i === activeFab.index + 1 ? ".next" : ""), {
						attributes: attributes
					}, [
						h("div.wrap" + (mobile ? ".full-height" : ""), [
							h("span.pillar-icon." + (_.find(state.pillars, {"name": hotspot.pillar}).icon) + "." + convertName(hotspot.pillar, "-"), hotspot.pillar),
							h("h3", hotspot.title),
						h("div.content", [
							getVNodeFromHMTL(htmlDecode(hotspot.html)),
							hotspot.assets ? _.chain(hotspot.assets)
								.map(asset => getVNodeFromHMTL(htmlDecode(asset.html || asset.JWCode ? `<a role="button" class="resource-item btn-jwlauncher" type="VID" jwpid="+${asset.JWCode}">Watch Video</a>` : '<div></div>'))).value() : ""
						]),
						]),
						mobile ? "" : hotspots[i - 1] ? h("button.btn.btn-primary.active.prev", hotspots[i - 1].title) : "",
						mobile ? "" : hotspots[i + 1] ? h("button.btn.btn-primary.active.next", hotspots[i + 1].title) : "",
					]);
				})
			)
		]));
}

function createHeaderPrimaryVDom(state) {
	return h("div.vdom", [
		state.standalone ? "" : h("button.close", "Close"),
		h("nav", [
			h("div.primary", [
				h("div.logo", [
					h("img", {
						src: "/images/cascadia-logo.png"
					})
				]),
				state.truckCab ? h("div.main-nav-wrap", [
					h("button.btn-back"),
					h("div.truck-label", state.truckCab),
					_.map(state.navs, nav => {
						return h("a.main-nav" + (nav === state.nav ? ".active" : "") +
							(state.truckCab === "" ? ".disabled" : ""), {
							href: "#" + nav,
							attributes: {
								"data-main-nav": nav
							}
						}, nav);
					})
				]) : ""
			])
		])
	]);
}
function createHeaderSecondaryVDom(state) {
	if (state.truckCab === "") {
		return h("div");
	}
	return h("div.vdom", [
		h("nav", [
			h("div.secondary", [
				h("button.btn-back"),
				h("div.truck-label", state.truckCab),
				state.nav === "explore" ? [
					h("div.btn-group", {
						attributes: {
							"data-toggle": "buttons"
						}
					}, _.map(state.views, (view) => {
						let inputAttrs = {
							type: "radio",
							name: "configurator-view",
							autocomplete: "off",
							"data-view": view
						};
						if (view === state.view) {
							inputAttrs.checked = "checked";
						}
						return h("label.btn" + (view === state.view ? ".btn-primary.active" : ".btn-default"), [
							h("input.view-nav", {
								attributes: inputAttrs
							}),
							view
						]);
					})),
					state.view === "exterior" ? _.map(state.pillars, (pillar) => {
						if (!state.dataReady) {
							return "";
						}
						let truckName = "Cascadia-" + state.truckCab,
							hotspots = true;

						try {
							if(state.truckCab && state.pathTree.FTL.Truck[truckName].Explore[_.capitalize(state.view)]){
								hotspots = _.chain(state.pathTree)
											.deepPluck("FTL.Truck." + truckName + ".Explore." + _.capitalize(state.view) + "." + pillar.name)
											.value();
							}	
						}
						catch(error) {
							window.___state_err = {state,path:'state.pathTree.FTL.Truck', truckName};
						}

						
						return h("a.pillar-nav." + pillar.id +
							(pillar.name === state.pillar && hotspots ? ".active" : "") +
							("." + pillar.icon) +
							(!hotspots ? ".disabled" : ""), {
							href: "#" + pillar.id,
							attributes: {
								"data-pillar": pillar.name
							}
						}, [
							h("span", pillar.name)
						]);
					}) : ""
				] : [
					h("div.build-options", _.map(state.viewOptions, (viewOptions) => {
							if (!state.dataReady) {
								return "";
							}
							return h("a.view-option-nav." + viewOptions.id +
								(viewOptions.name === state.viewOption ? ".active" : ""), {
								href: "#" + viewOptions.id,
								attributes: {
									"data-view-option": viewOptions.name
								}
							}, viewOptions.name);
						})
					)]
			])
		])
	]);
}
function createSelectorVDom(state) {
	let truckCabs = {
		"day": '126\" BBC Day Cab',
		"sleeper": '126\" BBC 72\" RR'
	};
	return (state.cabType === "" || state.truckCab === "") ? h("div.vdom.selector", [
		h("div#cab-selector", [
			h("div.cab.cab-day" + (state.cabType === "day" ? ".active" : "") +
				(state.cabType === "sleeper" ? ".inactive" : ""), {
				attributes: {
					"data-cab-type": "day",
					"data-truck-cab": truckCabs.day
				}
			}, [
				h("img", {
					src: "/images/select-day-cab.png"
				}),
				h("h2", truckCabs.day)
			]),
			h("div.cab.cab-sleeper" + (state.cabType === "sleeper" ? ".active" : "") +
				(state.cabType === "day" ? ".inactive" : ""), {
				attributes: {
					"data-cab-type": "sleeper",
					"data-truck-cab": truckCabs.sleeper
				}
			}, [
				h("img", {
					src: "/images/select-sleeper-cab.png"
				}),
				h("h2", truckCabs.sleeper)
			]),
		])
	]) : h("div");
}
function createInfoVDom(state) {
	// if (state.view === "interior") {
	// 	return generateInteriorBuilderUI(state);
	// } else if (state.view === "exterior") {
	// 	return generateExteriorBuilderUI(state);
	// } else if (!infoVTree) {
	// 	return h("div");
	// }
	// return infoVTree;
	return generateBuilderUI(state);
}

function createFabOverlayVDom(state) {
	return generateExplorerOverlay(state);
}

function createViewerVDom(state) {
	return h("div.vdom.viewers", {
		attributes: {
			"data-viewer": state.view,
			"data-mode": state.nav
		}
	}, [
		h("div#exterior-builder"),
		h("div#interior-builder"),
		h("div#hotspot-overlay"),
	]);
}

function renderFabOverlay(state) {
	let newFabOverlayTree = createFabOverlayVDom(state),
		fabOverlayPatches = virtualDom.diff(fabOverlayVTree, newFabOverlayTree);
	fabOverlayVNode = virtualDom.patch(fabOverlayVNode, fabOverlayPatches);
	fabOverlayVTree = newFabOverlayTree;
}
function render(state) {
	// render the UI
	let renderOverlayOnly = state.activeFab || state.clearActiveFab;
	if (!renderOverlayOnly) {
		// header
		let newHeaderTreePrimary = createHeaderPrimaryVDom(state),
			headerPatchesPrimary = virtualDom.diff(headerVTreePrimary, newHeaderTreePrimary);
		headerVNodePrimary = virtualDom.patch(headerVNodePrimary, headerPatchesPrimary);
		headerVTreePrimary = newHeaderTreePrimary;

		let newHeaderTreeSecondary = createHeaderSecondaryVDom(state),
			headerPatchesSecondary = virtualDom.diff(headerVTreeSecondary, newHeaderTreeSecondary);
		headerVNodeSecondary = virtualDom.patch(headerVNodeSecondary, headerPatchesSecondary);
		headerVTreeSecondary = newHeaderTreeSecondary;

		// selector
		let newSelectorTree = createSelectorVDom(state),
			selectorPatches = virtualDom.diff(selectorVTree, newSelectorTree);
		selectorVNode = virtualDom.patch(selectorVNode, selectorPatches);
		selectorVTree = newSelectorTree;

		// infobox
		let newInfoTree = createInfoVDom(state),
			infoPatches = virtualDom.diff(infoVTree, newInfoTree);
		infoVNode = virtualDom.patch(infoVNode, infoPatches);
		infoVTree = newInfoTree;

		// exterior and interior viewer
		let newViewerTree = createViewerVDom(state),
			viewerPatches = virtualDom.diff(viewerVTree, newViewerTree);
		viewerVNode = virtualDom.patch(viewerVNode, viewerPatches);
		viewerVTree = newViewerTree;
	}
	// fab overlay
	renderFabOverlay(state);

	// if interiorBuilder is setup update it
	if (interiorBuilder && !renderOverlayOnly) {
		interiorBuilder.update(state);
	}
	// if exteriorBuilder is setup update it
	if (exteriorBuilder && state.view === "exterior" && !renderOverlayOnly) {
		exteriorBuilder.update(state);
	}

	if (state.truckCab === "" || state.activeFab || state.view === "interior") {
		$("#drawer").hide();
	} else {
		$("#drawer").show();
	}

}

function initConfigurator(state) {

	// init header vDom and insert into DOM
	$headerContainerPrimary = $("#configurator-header-primary");
	headerVTreePrimary = createHeaderPrimaryVDom(state);
	headerVNodePrimary = virtualDom.create(headerVTreePrimary);
	$headerContainerPrimary.html(headerVNodePrimary);

	// init header vDom and insert into DOM
	$headerContainerSecondary = $("#configurator-header-secondary");
	headerVTreeSecondary = createHeaderSecondaryVDom(state);
	headerVNodeSecondary = virtualDom.create(headerVTreeSecondary);
	$headerContainerSecondary.html(headerVNodeSecondary);

	// init header vDom and insert into DOM
	$selectorContainer = $("#configurator-selector");
	selectorVTree = createSelectorVDom(state);
	selectorVNode = virtualDom.create(selectorVTree);
	$selectorContainer.html(selectorVNode);

	// init infobox vDom and insert into DOM
	$infoContainer = $("#configurator-infobox");
	infoVTree = createInfoVDom(state);
	infoVNode = virtualDom.create(infoVTree);
	$infoContainer.html(infoVNode);

	// init infobox vDom and insert into DOM
	$viewerContainer = $("#configurator-viewers");
	viewerVTree = createViewerVDom(state);
	viewerVNode = virtualDom.create(viewerVTree);
	$viewerContainer.html(viewerVNode);

	// init fab overlay vDom and insert into DOM
	$fabOverlayContainer = $("#hotspot-overlay");
	fabOverlayVTree = createFabOverlayVDom(state);
	fabOverlayVNode = virtualDom.create(fabOverlayVTree);
	$fabOverlayContainer.html(fabOverlayVNode);

}

function loadData() {
	let optionsMatrix$ = Rx.Observable.fromPromise(getOptionsMatrix());
	optionsMatrix$.subscribe(function (optionsMatrix) {
		store.dispatch({
			type: 'LOAD_OPTIONS_MATRIX',
			data: optionsMatrix
		});
	}, e => {
		console.log(e);
	});
	let adsFabs$ = Rx.Observable.fromPromise(getAdsFabs());
	adsFabs$.subscribe(function (fabs) {
		store.dispatch({
			type: 'LOAD_ADS_FABS',
			data: fabs
		});
		store.dispatch({
			type: 'FORMAT_ADS_PATH_TREE',
			data: fabs.path_tree
		});
	});
	let interiorMap$ = Rx.Observable.fromPromise(getFile("/static/configurator-mini/p4-interior-map.json"));
	interiorMap$.subscribe(function (map) {
		store.dispatch({
			type: 'LOAD_INTERIOR_MAP',
			data: map
		});
	});
	let exteriorMap$ = Rx.Observable.fromPromise(getFile("/static/configurator-mini/p4-exterior-map.json"));
	exteriorMap$.subscribe(function (map) {
		store.dispatch({
			type: 'LOAD_EXTERIOR_MAP',
			data: map
		});
	});

	let data$ = Rx.Observable.zip(optionsMatrix$, adsFabs$, interiorMap$, exteriorMap$);
	data$.subscribe(() => {
		let state = store.getState();

		initConfigurator(state);

		$("#configurator-mini").removeClass("loading");

		if (webgl) {
			// init configurator for interior view
			interiorBuilder = setupInteriorBuilder("#interior-builder", state, store);
		}
		// init configurator for exterior builder
		exteriorBuilder = setupExteriorBuilder("#exterior-builder", state, null, false);

		var resizeSource$ = Rx.Observable.fromEvent(window, "resize")
			.debounceTime(100);
		resizeSubscription = resizeSource$.subscribe(e => {
			let state = store.getState();
			console.log("resize event");
			exteriorBuilder.update(state);
			renderFabOverlay(state);
		});

		store.dispatch({
			type: 'ALL_DATA_LOADED',
			data: null
		});
		let truck = getHashParameter("truck"),
			view = getHashParameter("view"),
			pillar = getHashParameter("pillar").replace("_", " "),
			standalone = $("#standalone-configurator-mini").length > 0;
		if (truck || standalone) {
			store.dispatch({
				type: "DEEP_LINK_LOAD",
				data: {
					standalone,
					truck: truck,
					view: view || state.view,
					pillar: pillar || state.pillar
				}
			});
		}
		store$.subscribe(render);

	}, e => {
		console.log(e);
	});
}

function insertHTML() {
	var html = `<div id="configurator-mini" class="loading">
	<div id="configurator-header-primary"></div>
	<div id="configurator-selector"></div>
	<div id="configurator-viewers"></div>
	<div id="configurator-header-secondary"></div>
	<div id="drawer">  
		<a href="#" id="handle"><span class="handle-up-arrow left">&raquo;</span>Available Cab Options<span class="handle-up-arrow right">&raquo;</span></a>
		<div class="cab-options">
			<a href="#" class="cab-option disabled sleeper"><img src="/images/116-bbc-48-xt.png" alt=""><span>116" BBC 48 XT</span></a>
			<a href="#" class="cab-option disabled sleeper"><img src="/images/116-bbc-60-xt.png" alt=""><span>116" BBC 60 XT</span></a>
			<a href="#" class="cab-option disabled sleeper"><img src="/images/116-bbc-60-rr.png" alt=""><span>116" BBC 60 RR</span></a>
			<a href="#" class="cab-option disabled sleeper"><img src="/images/116-bbc-72-xt.png" alt=""><span>116" BBC 72 XT</span></a>
			<a href="#" class="cab-option disabled sleeper"><img src="/images/116-bbc-72-rr.png" alt=""><span>116" BBC 72 RR</span></a>
			<a href="#" class="cab-option disabled day"><img src="/images/116-bbc-day-cab.png" alt=""><span>116" BBC Day Cab</span></a>
			<a href="#" class="cab-option disabled sleeper"><img src="/images/126-bbc-48-xt.png" alt=""><span>126" BBC 48 XT</span></a>
			<a href="#" class="cab-option disabled sleeper"><img src="/images/126-bbc-60-xt.png" alt=""><span>126" BBC 60 XT</span></a>
			<a href="#" class="cab-option disabled sleeper"><img src="/images/126-bbc-60-rr.png" alt=""><span>126" BBC 60 RR</span></a>
			<a href="#" class="cab-option disabled sleeper"><img src="/images/126-bbc-72-xt.png" alt=""><span>126" BBC 72 XT</span></a>
			<a href="#" class="cab-option sleeper" data-cab-type="sleeper" data-truck-cab='126" BBC 72" RR'><img src="/images/126-bbc-72-rr.png" alt=""><span>126" BBC 72 RR</span></a>
			<a href="#" class="cab-option day" data-cab-type="day" data-truck-cab='126" BBC Day Cab'><img src="/images/126-bbc-day-cab.png" alt=""><span>126" BBC Day Cab</span></a>
		</div>
	</div>
</div>`;
	$("body").append(html);
}
insertHTML();
addHandlers();

(() => {
// load using deep links if we have them
	let truck = getHashParameter("truck"),
		view = getHashParameter("view"),
		pillar = getHashParameter("pillar").replace("_", " "),
		standalone = $("#standalone-configurator-mini").length > 0;
	if (truck || standalone) {
		launchConfigurator();
	}
})();

// subscribe to state changes